import MerchantGridCard from './MerchantGridCard'

export default MerchantGridCard
